module.exports = new __parcel__URL__("air-temp.c1678179.png").toString();